const SessionPriceResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'tickets/sessionprice',
        apiRequestParams.defaults(),
        {
            query: {
                method: 'GET',
            },
        }
    );
};

module.exports = SessionPriceResource;
